(function () {
  const app = document.querySelector('[data-b2b-florist-app]');
  if (!app) return;

  const root =
    window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';

  const endpoints = {
    cart: `${root}cart.js`,
    update: `${root}cart/update.js`
  };

  const cartCount = app.querySelector('[data-b2b-cart-count]');
  const searchInput = app.querySelector('[data-b2b-search]');
  const filterButtons = app.querySelectorAll('[data-b2b-filter]');
  const colorButtons = app.querySelectorAll('[data-b2b-color-filter]');
  const rows = Array.from(app.querySelectorAll('[data-b2b-product]'));
  const groups = Array.from(app.querySelectorAll('[data-b2b-group]'));

  let activeFilter = 'all';
  let activeColor = 'all';
  let activeColorCategory = 'all';
  let cartItemsByVariant = {};

  function toNumber(value, fallback) {
    const num = Number(value);
    return Number.isFinite(num) ? num : fallback;
  }

  async function getCart() {
    const response = await fetch(endpoints.cart, {
      headers: {
        Accept: 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('Unable to fetch cart');
    }

    return response.json();
  }

  async function updateCartQuantity(variantId, quantity) {
    const response = await fetch(endpoints.update, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        updates: {
          [variantId]: quantity
        }
      })
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.description || data.message || 'Unable to update cart');
    }

    return data;
  }

  function indexCart(cart) {
    cartItemsByVariant = {};

    cart.items.forEach((item) => {
      cartItemsByVariant[item.variant_id] = item.quantity;
    });

    if (cartCount) {
      cartCount.textContent = cart.item_count;

      if (cart.item_count > 0) {
        cartCount.classList.add('has-items');
      } else {
        cartCount.classList.remove('has-items');
      }
    }

    rows.forEach((row) => {
      const variantId = row.dataset.variantId;
      const input = row.querySelector('[data-b2b-qty]');
      if (!input) return;

      input.value = cartItemsByVariant[variantId] || 0;
    });
  }

  async function refreshCart() {
    try {
      const cart = await getCart();
      indexCart(cart);
    } catch (error) {
      console.warn(error);
    }
  }

  function getNextQty(row, direction) {
    const variantId = row.dataset.variantId;
    const currentQty = cartItemsByVariant[variantId] || 0;

    const min = toNumber(row.dataset.min, 1);
    const max = row.dataset.max ? toNumber(row.dataset.max, null) : null;
    const step = toNumber(row.dataset.step, 1);

    let nextQty;

    if (direction === 'plus') {
      if (currentQty === 0) {
        nextQty = Math.max(min, step);
      } else {
        nextQty = currentQty + step;
      }

      if (max !== null && nextQty > max) {
        nextQty = max;
      }
    } else {
      nextQty = currentQty - step;

      if (nextQty < min) {
        nextQty = 0;
      }
    }

    return Math.max(0, nextQty);
  }

  async function handleStepper(row, direction) {
    const variantId = row.dataset.variantId;
    const nextQty = getNextQty(row, direction);

    row.classList.add('is-loading');

    try {
      const cart = await updateCartQuantity(variantId, nextQty);
      indexCart(cart);
    } catch (error) {
      alert(error.message || 'Could not update cart quantity.');
    } finally {
      row.classList.remove('is-loading');
    }
  }

  function rowMatchesFilters(row, query) {
    const searchText = (row.dataset.search || '').toLowerCase();
    const category = row.dataset.category || '';
    const available = row.dataset.available === 'true';
    const color = (row.dataset.color || '').toLowerCase();

    const matchesSearch = !query || searchText.includes(query);

    const matchesMainFilter =
      activeFilter === 'all' ||
      (activeFilter === 'stock' && available) ||
      category === activeFilter;

    const matchesColor =
      activeColor === 'all' ||
      (category === activeColorCategory && color === activeColor);

    return matchesSearch && matchesMainFilter && matchesColor;
  }

  function updateVisibleGroups() {
    groups.forEach((group) => {
      const category = group.dataset.b2bGroup || '';

      const hasVisibleProducts = rows.some((row) => {
        return row.dataset.category === category && !row.classList.contains('is-hidden');
      });

      group.classList.toggle('is-hidden', !hasVisibleProducts);
    });
  }

  function applyFilters() {
    const query = searchInput ? searchInput.value.trim().toLowerCase() : '';

    rows.forEach((row) => {
      row.classList.toggle('is-hidden', !rowMatchesFilters(row, query));
    });

    updateVisibleGroups();
  }

  function resetColorFilter() {
    activeColor = 'all';
    activeColorCategory = 'all';

    colorButtons.forEach((button) => {
      button.classList.remove('is-active');
    });
  }

  function setMainFilter(button) {
    filterButtons.forEach((btn) => {
      btn.classList.remove('is-active');
    });

    button.classList.add('is-active');

    activeFilter = button.dataset.b2bFilter || 'all';
    resetColorFilter();
    applyFilters();
  }

  function setColorFilter(button) {
    const selectedColor = button.dataset.b2bColorFilter;
    const selectedCategory = button.dataset.b2bColorCategory;
    const alreadyActive = button.classList.contains('is-active');

    colorButtons.forEach((btn) => {
      btn.classList.remove('is-active');
    });

    if (alreadyActive) {
      activeColor = 'all';
      activeColorCategory = 'all';
    } else {
      button.classList.add('is-active');
      activeFilter = selectedCategory;
      activeColor = selectedColor;
      activeColorCategory = selectedCategory;
    }

    filterButtons.forEach((btn) => {
      btn.classList.toggle('is-active', btn.dataset.b2bFilter === activeFilter);
    });

    applyFilters();
  }

  app.addEventListener('click', function (event) {
    const plusButton = event.target.closest('[data-b2b-plus]');
    const minusButton = event.target.closest('[data-b2b-minus]');

    if (!plusButton && !minusButton) return;

    const row = event.target.closest('[data-b2b-product]');
    if (!row) return;

    handleStepper(row, plusButton ? 'plus' : 'minus');
  });

  if (searchInput) {
    searchInput.addEventListener('input', applyFilters);
  }

  filterButtons.forEach((button) => {
    button.addEventListener('click', function () {
      setMainFilter(button);
    });
  });

  colorButtons.forEach((button) => {
    button.addEventListener('click', function () {
      setColorFilter(button);
    });
  });

  refreshCart();
  applyFilters();
})();